import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 bg-brand-cream" data-id="element-92">
      <div className="max-w-3xl mx-auto text-center" data-id="element-93">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-gold/20 border border-brand-gold/40 text-brand-graphite font-bold text-xs sm:text-sm mb-3 shadow-sm" data-id="element-94">
          <span data-id="element-95">✨</span>
          <span data-id="element-96">VALIDATED TEACHING METHOD</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-extrabold text-brand-graphite leading-tight mb-3" data-id="element-97">
          The Integrated Planning System for Yoga Instructors
        </h1>

        <p className="text-base sm:text-lg text-brand-graphite/90 font-medium leading-snug mb-4 max-w-2xl mx-auto" data-id="element-98">
          Save time, reclaim your serenity, and elevate your teaching — without
          the exhaustion of manual planning.
        </p>

        <div className="inline-block bg-brand-petrol text-white px-4 py-1.5 rounded-md mb-4 shadow-md" data-id="element-99">
          <p className="font-bold text-sm sm:text-base tracking-wide" data-id="element-100">
            Yoga Ready 6-in-1 Box Set
          </p>
        </div>

        <div className="mb-5" data-id="element-101">
          <a href="#pricing" className="block cursor-pointer" data-id="element-102">
            <img src="https://cdn.magicpatterns.com/uploads/4bHTedV1cSBKAqW87FCj9F/ChatGPT_Image_14_jun_2026,_12_05_24_a.m..png" alt="Yoga Ready 6-in-1 Box Set" className="w-full h-auto object-contain max-w-md sm:max-w-lg mx-auto hover:scale-[1.03] transition-transform duration-300 drop-shadow-2xl" data-id="element-103" />
          </a>
        </div>

        <div className="mb-3" data-id="element-104">
          <CTAButton className="max-w-md mx-auto" data-id="element-105">
            🚀 YES, I WANT MY METHOD NOW
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-1 text-sm text-brand-graphite font-bold" data-id="element-106">
          <div className="flex items-center gap-1" data-id="element-107">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-108" />
            <span data-id="element-109">4.9/5 — Verified Professional Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-110">•</span>
          <div className="flex items-center gap-1" data-id="element-111">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-112" />
            <span data-id="element-113">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}